import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        sms_logs: {data: [], current_page: 1, total: 0, per_page: 10},
        campaigns: {data: [], current_page: 1, total: 0, per_page: 10},
        units: {balance: 0},
        recipients: {data: [], current_page: 1, total: 0, per_page: 10},
        campaign: null,
        errors: {
            data: {
                errors: {
                    name: [],
                    message: [],
                    send_to: [],
                    scheduled: [],
                    send_at: [],
                    status: []
                }
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false
    },
    getters: {
        loading: state => state.loading,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        sms_logs: state => state.sms_logs,
        campaigns: state => state.campaigns,
        campaign: state => state.campaign,
        dialogVisible: state => state.dialogVisible,
        recipients: state => state.recipients,
        units: state => state.units

    },
    mutations: {
        setCampaign(state, data) {
            state.campaign = data;
        },
        setRecipients(state, data) {
            state.recipients = data;
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setSmsLogs(state, data) {
            state.sms_logs = data;
        },
        setCampaigns(state, data) {
            state.campaigns = data;
        },
        setUnits(state, data) {
            state.units = data;
        },
        setLoading(state, data) {
            state.loading = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                            message: [],
                            send_to: [],
                            scheduled: [],
                            send_at: [],
                            status: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getSmsLogs({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getSmsLogs(filters);
                commit('setSmsLogs', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },
        async resendSms({commit, dispatch}, data) {
            commit('setLoading', true);
            try {
                const response = await api.resendSms(data);
                commit('setLoading', false);
                ElMessage.success({
                    message: response.message,
                    duration: 10000
                });
                dispatch('getSmsLogs', {
                    paginate: true
                })

            } catch (e) {
                commit('setLoading', false);
                ElMessage.error(
                    {
                        message: e.response.data.message,
                        duration: 10000
                    });
            }
        },

        // campaigns
        async getCampaigns({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getCampaigns(filters);
                commit('setCampaigns', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },
        async getBalance({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getBalance(filters);
                commit('setUnits', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },
        async createCampaign({dispatch, commit}, data) {
            try {

                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createCampaign(data);
                ElMessage.success('Campaign created successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
                dispatch('getCampaigns', {
                    paginate: true
                })
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async editCampaign({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editCampaign(data);
                ElMessage.success('Campaign updated successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
                dispatch('getCampaigns', {
                    paginate: true
                })
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },
        async getCampaign({commit}, id) {
            try {
                const response = await api.getCampaign(id);
                commit('setCampaign', response);
            } catch (e) {
                ElMessage.error('Error fetching campaign!');
            }
        },
        async getRecipients({commit}, data) {
            commit('setLoading', true);
            try {
                const response = await api.getRecipients(data);
                commit('setRecipients', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

        async exportSmsLogsReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportSmsLogsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'SMS_Logs_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },

        async exportCampaignsReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportCampaignsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Campaigns_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },
    }
}
